if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// SLICK DEFAULTS
const prevArrow = `<button type="button" class="slick-prev slick-arrow"><span>Prev</span><svg class="arrow arrow-left" fill="#156d79" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="38" height="20.76" viewBox="0 0 38 20.76"><polygon class="cls-1" points="33.05 0 31.34 .82 35.44 9.43 0 9.43 0 11.33 35.44 11.33 31.34 19.94 33.05 20.76 38 10.38 33.05 0"/></svg><svg class="circle" height="40" width="40"><circle cx="50%" cy="50%" r="30" stroke="#d24858" stroke-width="1" fill="none"></circle></svg></button>`;
const nextArrow = `<button type="button" class="slick-next slick-arrow"><span>Next</span><svg class="arrow arrow-right"  fill="#156d79" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="38" height="20.76" viewBox="0 0 38 20.76"><polygon class="cls-1" points="33.05 0 31.34 .82 35.44 9.43 0 9.43 0 11.33 35.44 11.33 31.34 19.94 33.05 20.76 38 10.38 33.05 0"/></svg><svg class="circle" height="40" width="40"><circle cx="50%" cy="50%" r="30" stroke="#d24858" stroke-width="1" fill="none"></circle></svg></button>`;
const slickOps = {
    accessibility: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow
};

// Slick Slider with current slide number
const setSlickShowIndex = ( selector = '[data-slick_showIndex]' ) => {
    $(selector).each((i, el) => {
        let currentIndex = '1';
        $(el).on('init', (e, s)=> {
            let slideCount = s.slideCount;
            if ( s.options.arrows ) {
                $(s.options.appendDots).append(`<div class="slick-current_index"><span class="large">${currentIndex}</span>/<span class="small">${slideCount}</span></div>`);
            }
        });

        $(el).on('beforeChange', (e, s, c, n)=> {
            currentIndex = (`${(n+1)}`).slice(-2);
            if ( s.options.arrows ) {
                $('.slick-current_index span.large', s.options.appendDots).text(currentIndex);
            }

            if( s.options.autoplay ) {
                $('.slick-current_index', s.options.appendDots).removeClass('inprogress');
                setTimeout(() => $('.slick-current_index', s.options.appendDots).addClass('inprogress'), 10);
            }
        });
    });
};

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    setSlickShowIndex();

    $('[data-fancybox]').fancybox({
        toolbar  : false,
        smallBtn : true
    });

    $('.sym-slides').slick({
        accessibility: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    });

    $('.slider-home-slick').slick({
        accessibility: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendDots: '.slider-home__nav',
    });

    // top-reason
    $('.sym-top-reason').slick( {
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        appendDots: '.top-reason__controls'
        // responsive: [
        //     {
        //         breakpoint: 600,
        //         settings: {
        //             adaptiveHeight: true,
        //         }
        //     }
        // ]
    });

    $('.reviews-slick').slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        slide: '.reviews-block__item',
        appendDots: '.reviews-block__controls',
        appendArrows: '.reviews-block__controls',
    });
    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

     //tabs content
     document.querySelectorAll('.tab-js li').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.tab-js li').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            activeContentItem(btn.dataset.tag);
        });
        if (i === 0) btn.click();
    });
    
    function activeContentItem(tag){
        document.querySelectorAll('.tab-item-js').forEach( item => {
            item.classList.remove('active');
            if ( tag === 'all' || tag === item.dataset.tag ) {
                let data_tag =item.getAttribute('data-tag');
                item.classList.add('active');
            }
        }); 
    }

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))").click(function(e){
		e.preventDefault();
		let strAncla = $(this).prop('hash').substr(1);
		animateto(strAncla);
	});

})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from = window.pageYOffset
    var to = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()
    
    //time interval
    var timer = setInterval(function() {
    var time = new Date().getTime() - start
    
    if(from <= to ){
        var y = easeInOutQuart(time, from, to - from, duration)
    } else {
        var y = easeInOutQuart(time, from, -(from - to), duration)
    }
    window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)
    }, 1000 / 60);
    window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
     return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
    function offset(el) {
    var rect = el.getBoundingClientRect(),
     scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
     scrollTop = window.pageYOffset || document.documentElement.scrollTop;
     return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }

    /*
        ? Open Scroll Animation If The Url Has '#'
    */
    window.addEventListener("load", (event) => {
        let sectionId = location.hash.substring(1);
        let sectionFromUrl = document.getElementById(sectionId);
        if( sectionFromUrl ){
            sectionFromUrl.scrollIntoView({ 
                behavior: "smooth", 
                block: "center"
            });
            /*
                * The properties used for the parameter 'block' it's for indicate where the section found should be respect the screen 'start, center, end'
            */
        };
    });
    /*
        ? Close Scroll Animation If The Url Has '#'
    */
